<template>
  <div class="common">
    <div class="spaceLeft page-main no-shadow">
        文件名称：
        <div class="file-item ellipsis">{{fileList[0]&&fileList[0].name}}</div>
        <a-upload
        :file-list="fileList"
        :before-upload="beforeFileUpload"
        :showUploadList="false"
        >
            <a-button class="btn-blue-line" style="margin-left:20px;">选择文件 </a-button>
        </a-upload>
        <a-button
        type="primary"

        @click="handleFileUpload"
        :disabled="fileList.length === 0"
        :loading="uploading"
        style="margin-left:20px">导入</a-button>
        <a href="/static/templates/circleExcel.xls" download="circleExcel.xls" class="down-text">Excel模板下载</a>
    </div>
    <div class="table-common">
      <a-table
        size="middle"
        :columns="columns"
        :data-source="tableData"
        :pagination="false"
        :loading="loading"
        :row-key="(record,index) => record.id+'_'+index"
        bordered
        :locale="{emptyText: '暂无数据'}"
        :row-selection="tableSelect"
      >
        <template slot="roleCd" slot-scope="text">{{parseRole(text)}}</template>
      </a-table>
      <div :class="{'table-total':pagination.total>0,'table-total-none':pagination.total==0}">
        共有记录：
        <span class="">{{pagination.total}} 条</span>
        已导入推荐：
        <span class="text-color-blue">{{selectedRows.length}} 条</span>
        <a-button class="btn-blue-line" :disabled="selectedRowKeys.length==0" @click="onExport">推荐</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {addRecommend} from "@/api/circle.js"
export default {
    name:"recommendMulti",
    data() {
        return {
            name:"importFile",
            url:"/user/circle/import",
            fileList:[],
            uploading:false,
            columns: [
                {
                    title:"企业名称",
                    dataIndex: "cstNm",
                },
                {
                    title:"社会信用代码	",
                    dataIndex: "cstOrgCode",
                },
                {
                    title:"联系人	",
                    dataIndex: "contactPerson",
                },
                {
                    title: "联系电话",
                    dataIndex: "ctcPsnTel",
                },
                {
                    title: "角色",
                    dataIndex: "roleCd",
                    scopedSlots: { customRender: "roleCd" }
                },
                // {
                //     title: "保理商",
                //     dataIndex: "tenantName",
                // },

            ],
            tableData: [],
            pagination: {
                pageSize: 10,
                current: 1,
                sortField: "",
                sortOrder: "",
                total: 0,
            },
            loading: false,
            selectedRows: [],
            selectedRowKeys:[],

        }
    },
    computed:{
        tableSelect(){
            return {
                selectedRowKeys: this.selectedRowKeys,
                selectedRows: this.selectedRows,
                onChange: this.onTableChange
            }
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        beforeFileUpload(file){
            this.fileList = [...this.fileList, file];
            return false;
        },
        handleFileUpload() {
            const formData = new FormData();
            this.fileList.forEach(file => {
                formData.append(this.name, file);
            });
            this.uploading = true;
            this.axios({
                url:this.url,
                data:formData,
                isTransform:false
            }).then((res)=> {
                this.uploading = false;
                if(res.data){
                    this.tableData = res.data;
                }
            })
            .catch((err)=> {
                this.fileList = [];
                this.uploading = false;
            });
        },
        onTableChange(selectedRows, data, data2) { //表格选择回调
            this.selectedRowKeys = selectedRows;
            this.selectedRows = data;
        },
        parseRole(roleId) {
            if (this.utils.isUndefined(roleId)) {
                return;
            }
            const resultArray = roleId.split(',');
            let result = '';
            for (let i = 0; i < resultArray.length; i++) {
            if (resultArray[i] === '0') {
                result += '下游客户';
            } else if (resultArray[i] === '1') {
                result += '上游客户';
            }
            if (i < resultArray.length - 1) {
                result += ' , ';
            }
            }
            return result;
        },
        onExport(){
            addRecommend(this.selectedRows,true)
            .then(res => {
                this.$message.success("已成功推荐，请联系平台发送邀请码");
                this.goBack();
            })
            .catch(err => {
                console.log(err);
            })
        },
        goBack(){
            this.$router.go(-1);
            this.MENUAPI.reloadRouter();
        }
    },
    activated() {

    },
};
</script>
<style scoped>
  .file-item{
      background: #e5e7e8;
      line-height: 30px;
      height: 30px;
      padding: 0 10px;
      width: 240px;
      margin:0 10px;
  }
  .down-text{
      margin-left:20px;
      font-size: 12px;
      text-decoration: underline;
  }
  .table-common{
      margin-top:20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/account/circle/recommend/recommend-multi.vue